import type { TFunction } from 'i18next';

export const UPLOAD_ERROR_CODES = ['UPLOAD_TOO_LARGE', 'FILE_TOO_LARGE'] as const;

type UploadErrorCode = (typeof UPLOAD_ERROR_CODES)[number];

const UPLOAD_ERROR_PATTERN = new RegExp(`^(${UPLOAD_ERROR_CODES.join('|')})(?::\\s*(.+))?$`);

export const translateUploadError = (message: string, t: TFunction): string | undefined => {
  const match = UPLOAD_ERROR_PATTERN.exec(message.trim());
  if (!match) return undefined;

  const code = match[1] as UploadErrorCode;
  const size = match[2];

  return size ? t(`upload_errors.${code}`, { size }) : t(`upload_errors.${code}_NO_LIMIT`);
};
